import React from 'react';
import styled from 'styled-components';
import 'modern-normalize'; // Normalize styles for consistent rendering in modern browsers

import { useScrollSpy } from '../hooks/useScrollSpy';
import { QUERIES } from '../constants/mediaQueries';
import GlobalStyles from '../styles/GlobalStyles';
import Logo from './Logo';
import Nav from './Nav';
import Footer from './Footer';
import { WhatsAppButton } from './WhatsAppButton';
import ScrollToTopButton from './ScrollToTopButton';

interface LayoutProps {
  children: React.ReactNode;
}

const LayoutStyles = styled.main`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const HeaderStyles = styled.header`
  border-bottom: var(--border-default);
  background-color: var(--color-neutral-white);
  box-shadow: var(--box-shadow-subtle);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--spacing-small) var(--spacing-large);
  gap: var(--spacing-large);
  position: sticky;
  top: 0;
  height: var(--height-header);
  z-index: 100;

  ${QUERIES.maxTablet} {
    padding: var(--spacing-base);
  }
`;

const ContentStyles = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-grow: 1;
  min-height: 85vh;
  overflow-x: auto;
`;

const Layout: React.FC<LayoutProps> = ({ children }) => {
  // Use the scroll spy hook to update URL with section anchors as user scrolls
  // We set offset to match the header height
  useScrollSpy({
    offset: 90, // Slightly larger than header height (80px) to trigger earlier
    debounceTime: 100,
    updateURL: true,
    updateOnLoad: true,
  });

  return (
    <>
      <GlobalStyles />
      <LayoutStyles>
        <HeaderStyles>
          <Logo />
          <Nav />
        </HeaderStyles>
        <ContentStyles>{children}</ContentStyles>
        <Footer />
        <WhatsAppButton />
        <ScrollToTopButton threshold={300} />
      </LayoutStyles>
    </>
  );
};

export default Layout;
